import { render, staticRenderFns } from "./correspondance.vue?vue&type=template&id=79a1ea6b&scoped=true"
import script from "./correspondance.vue?vue&type=script&lang=js"
export * from "./correspondance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a1ea6b",
  null
  
)

export default component.exports